<div class="cell auto grid-y cell-block-y blockContent" *ngIf="study">
    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'common.sales'"></h2>

        <table class="_tableColor">
            <thead>
            <tr class="_titlePartTable">
                <th [i18nKey]="'common.month'"></th>
                <th class="_numberColumn" *ngFor="let menuSalesHistory of study.menusSalesHistories">
                    {{menuSalesHistory.label}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let period of study.periods; index as i">
                <td>
                    {{period}}
                </td>
                <td class="_number" *ngFor="let menuSales of study.menusSalesHistories">
                    {{menuSales.data[i] | number:'1.0'}}
                </td>
            </tr>
            </tbody>
        </table>

        <div class="cell shrink grid-x grid-padding-x grid-padding-y">
            <canvas baseChart
                    [datasets]="study.menusSalesHistories"
                    [labels]="study.periods"
                    [options]="chartOptions"
                    [type]="'line'"></canvas>
        </div>
    </section>

    <section class="cell shrink studyPart">
        <h2 class="studyPart-title"[i18nKey]="'common.total'"></h2>

        <div class="grid-x grid-margin-x">
            <ng-container *ngFor="let menuSales of study.menusSalesHistories; index as i">
                <div class="cell shrink salesHistory"
                     [style.background-color]="buildRgbaCode(colorsRgbCodes[i], 0.2)">
                    <span class="salesHistory-label">{{menuSales.label}}</span>
                    <span class="salesHistory-value"
                          [style.color]="colors[i]">{{sumData(menuSales.data) | number:'1.0'}}</span>
                </div>
            </ng-container>
        </div>
    </section>
</div>
